import styled from "styled-components";

export const DataTableTemplateContainer = styled.div`
  width: 100%;
  height: max-content;

  .MuiDataGrid-main {
    overflow: initial;
    z-index: 80;
  }

  .MuiDataGrid-virtualScroller {
    overflow: initial;
    overflow-y: initial !important;
  }

  .MuiDataGrid-columnHeader {
    background: none !important;

    :has(div:empty) {
      min-width: initial !important;
    }
  }

  .MuiDataGrid-row,
  .MuiDataGrid-virtualScrollerRenderZone {
    width: 100% !important;
  }

  .MuiDataGrid-withBorderColor {
    max-width: 100% !important;
    width: 100% !important;
  }

  .MuiDataGrid-columnHeaderRow,
  .MuiDataGrid-columnHeadersInner {
    width: 100%;
  }

  .MuiDataGrid-virtualScrollerContent {
    max-height: 100%;
  }

  .MuiDataGrid-iconSeparator {
    display: none;
  }

  .MuiDataGrid-root {
    border-radius: 4px;
  }

  .MuiDataGrid-withBorderColor,
  .MuiDataGrid-root {
    border-color: ${({ theme }) => theme?.console.tableBorderColor} !important;
  }

  .MuiDataGrid-columnHeaderTitle,
  .MuiDataGrid-columnHeaderTitleContainerContent {
    font: 600 0.875rem/1.09375rem "Inter";
  }

  .MuiDataGrid-columnHeaderTitle,
  .MuiDataGrid-columnHeaderTitleContainerContent,
  .MuiButtonBase-root-MuiIconButton-root {
    color: ${({ theme }) => theme.console.sidebar.titleColor};
  }

  .MuiDataGrid-cell {
    color: ${({ theme }) => theme.console.cardDescriptionColor};
  }

  [data-testid="CheckBoxIcon"],
  [data-testid="IndeterminateCheckBoxIcon"] {
    color: #605cff !important;
  }

  .MuiTablePagination-displayedRows,
  .MuiDataGrid-selectedRowCount {
    color: ${({ theme }) => theme.console.sidebar.titleColor} !important;
    font: 500 0.875rem/1.09375rem "Inter";
    margin: 0;
  }

  .MuiSvgIcon-root {
    border-radius: 2px;
    color: ${({ theme }) => theme.console.sidebar.titleColor} !important;
  }

  .Mui-disabled {
    opacity: 0.6;
  }

  .MuiDataGrid-root *:focus,
  .MuiDataGrid-cellCheckbox,
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within,
  .MuiDataGrid-root .MuiDataGrid-cell:focus-within {
    outline: none !important;
  }

  .MuiDataGrid-overlay {
    background: transparent;
    backdrop-filter: blur(3px);
  }

  .MuiTablePagination-actions {
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme?.console.tableBorderColor};

    button:nth-child(1) {
      border-right: 2px solid ${({ theme }) => theme?.console.tableBorderColor};
    }
    button:nth-child(2) {
      border-left: none !important;
    }

    .MuiButtonBase-root.MuiIconButton-root {
      width: 35px;
      height: 35px;
      border-radius: 0;
      height: max-content;
    }
  }

  .footer {
    padding: 0.75rem 1rem !important;
  }

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  [data-field="dots-icon"] {
    overflow: visible !important;
  }
`;

export const NoDataToShow = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.console.sidebar.titleColor};
`;
